import { render, staticRenderFns } from "./RegisterBasic.vue?vue&type=template&id=456c5dd8&scoped=true"
import script from "./RegisterBasic.vue?vue&type=script&lang=js"
export * from "./RegisterBasic.vue?vue&type=script&lang=js"
import style0 from "./RegisterBasic.vue?vue&type=style&index=0&id=456c5dd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c5dd8",
  null
  
)

export default component.exports